import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  <path fill="currentColor" d="M14 .5H2C1.175.5.5075 1.175.5075 2L.5 15.5l3-3H14c.825 0 1.5-.675 1.5-1.5V2c0-.825-.675-1.5-1.5-1.5M5.75 7.25h-1.5v-1.5h1.5zm3 0h-1.5v-1.5h1.5zm3 0h-1.5v-1.5h1.5z" />
, 'DisplayChatx');
